import { render, staticRenderFns } from "./OtherSavingOptionsMobile.vue?vue&type=template&id=ab64888e&"
import script from "./OtherSavingOptionsMobile.vue?vue&type=script&lang=js&"
export * from "./OtherSavingOptionsMobile.vue?vue&type=script&lang=js&"
import style0 from "./OtherSavingOptionsMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports